import { render, staticRenderFns } from "./WriteApprovalCard.vue?vue&type=template&id=1b88adab&scoped=true&"
import script from "./WriteApprovalCard.vue?vue&type=script&lang=js&"
export * from "./WriteApprovalCard.vue?vue&type=script&lang=js&"
import style0 from "./WriteApprovalCard.vue?vue&type=style&index=0&id=1b88adab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b88adab",
  null
  
)

export default component.exports